//const baseUrl="https://ag.sport909.com/api/";
const baseUrl="https://api.sport909.com/api/";
//const baseUrl="https://aaa-api-33504700051.asia-southeast1.run.app/api/";
//const baseUrl = "https://localhost:44356/api/";

export { baseUrl };
